import {
  LuArrowDown,
  LuArrowDownToLine,
  LuArrowUp,
  LuArrowUpFromLine,
} from 'react-icons/lu';
import {COLOR_BLACK_2} from '../../../../../config/constants/colorCodes';
import {COMMENT_LIST_LIMIT} from '../../../../../core/entities/community/constants';
import {
  type CommentListStatus,
  CommentListStatusType,
} from '../../../../../core/entities/community/schema';

const BUTTON_CLASS_BASE = 'flex justify-center items-center';
const BUTTON_TEXT_CLASS = 'text-base text-black-2 font-bold leading';

type Props = {
  hasItem: boolean;
  hasPaging: boolean;
  previousCursor: number;
  nextCursor: number;
  setPageCursor: (cursor: number) => void;
  setIsBackward: (isBackward: boolean) => void;
  setIsInitial: (isInitial: boolean) => void;
  commentListStatus: CommentListStatus;
  scrollToTopItem: () => void;
  scrollToBottomItem: () => void;
};

export const CommentListPaging: React.FC<Props> = ({
  hasItem,
  hasPaging,
  previousCursor,
  nextCursor,
  setPageCursor,
  setIsBackward,
  setIsInitial,
  commentListStatus,
  scrollToTopItem,
  scrollToBottomItem,
}) => {
  const isBeforePagingDisabled =
    !hasPaging || commentListStatus === CommentListStatusType.oldest;
  const isNextPagingDisabled =
    !hasPaging || commentListStatus === CommentListStatusType.latest;

  return (
    <>
      <div className="flex justify-between items-center py-12 px-16 bg-background-2">
        <button
          className={`${BUTTON_CLASS_BASE} ${isBeforePagingDisabled ? 'opacity-40' : 'hover:opacity-80'}`}
          onClick={() => {
            if (!hasItem) return;
            setPageCursor(1);
            setIsBackward(false);
            setIsInitial(false);
            setTimeout(() => {
              scrollToTopItem();
            }, 50);
          }}
          disabled={isBeforePagingDisabled}
        >
          <div className="mr-8">
            <LuArrowDownToLine size={20} color={COLOR_BLACK_2} />
          </div>
          <p className={BUTTON_TEXT_CLASS}>最初から</p>
        </button>
        <button
          className={`${BUTTON_CLASS_BASE} ${isBeforePagingDisabled ? 'opacity-40' : 'hover:opacity-80'}`}
          onClick={() => {
            if (!hasItem) return;
            setPageCursor(previousCursor);
            setIsBackward(true);
            setIsInitial(false);
          }}
          disabled={isBeforePagingDisabled}
        >
          <div className="mr-8">
            <LuArrowUp size={20} color={COLOR_BLACK_2} />
          </div>
          <p className={BUTTON_TEXT_CLASS}>前の{COMMENT_LIST_LIMIT}件</p>
        </button>
        <button
          className={`${BUTTON_CLASS_BASE} ${isNextPagingDisabled ? 'opacity-40' : 'hover:opacity-80'}`}
          onClick={() => {
            if (!hasItem) return;
            setPageCursor(nextCursor);
            setIsBackward(false);
            setIsInitial(false);
          }}
          disabled={isNextPagingDisabled}
        >
          <div className="mr-8">
            <LuArrowDown size={20} color={COLOR_BLACK_2} />
          </div>
          <p className={BUTTON_TEXT_CLASS}>次の{COMMENT_LIST_LIMIT}件</p>
        </button>
        <button
          className={`${BUTTON_CLASS_BASE} ${isNextPagingDisabled ? 'opacity-40' : 'hover:opacity-80'}`}
          onClick={() => {
            if (!hasItem) return;
            setPageCursor(0);
            setIsBackward(true);
            setIsInitial(true);
            setTimeout(() => {
              scrollToBottomItem();
            }, 300); // リストの再取得が終わるのを待つ
          }}
          disabled={isNextPagingDisabled}
        >
          <div className="mr-8">
            <LuArrowUpFromLine size={20} color={COLOR_BLACK_2} />
          </div>
          <p className={BUTTON_TEXT_CLASS}>最新</p>
        </button>
      </div>
    </>
  );
};
